import React, { createContext, useState, useEffect, useContext } from 'react'
import { toUtf8 } from 'web3-utils'

import { AccountContext } from 'contexts/AccountProvider'

export const PoolListContext = createContext({
  poolList: [],
})

const PoolListProvider = ({ children }) => {
  const [poolList, setPoolList] = useState([])
  const { poolsContract } = useContext(AccountContext)

  const getLatestName = async (lotteryPool, pid) => {
    const nameEvents = await lotteryPool.getPastEvents('PoolNameChange', {
      filter: {
        poolId: pid.toString(),
      },
      fromBlock: 1,
      toBlock: 'latest',
    })
    let nameEvent = await nameEvents.pop()
    let name = 'you bet!'
    let transactionHash = ''
    if (nameEvent !== undefined) {
      name = toUtf8(nameEvent.returnValues.name)
      transactionHash = nameEvent.transactionHash
    }
    return { name, transactionHash }
  }
  const list = []
  const poolListData = async () => {
    const poolLength = await poolsContract.methods.poolLength().call()
    for (let pid = 0; pid < poolLength; pid++) {
      const pool = await poolsContract.methods.pools(pid).call()
      const {
        token,
        balance,
        reward,
        weight,
        owner,
        size,
        tickets,
        weightBalance,
        expiry,
        status,
      } = pool

      const { name, transactionHash } = await getLatestName(poolsContract, pid)
      list.push({
        pid,
        token,
        balance,
        reward,
        weight,
        owner,
        size,
        tickets,
        weightBalance,
        expiry,
        status,
        name,
        transactionHash,
      })
    }

    const poolListSorted = list.sort((a, b) => {
      if (a.weight === b.weight) {
        if (a === '') return 1
        if (b === '') return -1
        return a.name && a.name.localeCompare(b.name)
      }
      return a.weight < b.weight ? 1 : -1
    })
    setPoolList(poolListSorted)
  }

  useEffect(() => {
    if (poolsContract) {
      // console.log('poolsContract', poolsContract)
      poolListData()
    }
  }, [poolsContract])

  return (
    <PoolListContext.Provider value={{ poolList }}>
      {children}
    </PoolListContext.Provider>
  )
}

export default PoolListProvider
